import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import LicenseMessage from "./wizard/LicenseMessage";
import LicenseIdentificationForm from "./wizard/LicenseIdentificationForm";
import LicenseProductForm from "./wizard/LicenseProductForm";
import LicenseRegistrationForm from "./wizard/LicenseRegistrationForm";
import LicenseRequest from "./wizard/LicenseRequest";

import imgHelp from "../../../resources/img/svgicons/help.svg";

class LicenseWizard extends Component {
    getWizardStep = (step, subtitle = "") => {
        if (this.props.onlineActivation) {
            if (this.props.processStep === step) {
                return (
                    <div className="col-xs-4 online-step active">
                        {step}.
                        <div className="setup-subtitle">
                            <Translate value={subtitle} />
                        </div>
                    </div>
                );
            }

            if (this.props.processStep > step) {
                return (
                    <div className="col-xs-4 online-step done">
                        {step}.
                        <div className="setup-subtitle">
                            <Translate value={subtitle} />
                        </div>
                    </div>
                );
            }

            return (
                <div className="col-xs-4 online-step">
                    {step}.
                    <div className="setup-subtitle">
                        <Translate value={subtitle} />
                    </div>
                </div>
            );
        }

        if (this.props.processStep === step) {
            return (
                <div className="col-xs-3 step active">
                    {step}.
                    <div className="setup-subtitle">
                        <Translate value={subtitle} />
                    </div>
                </div>
            );
        }

        if (this.props.processStep > step) {
            return (
                <div className="col-xs-3 step done">
                    {step}.
                    <div className="setup-subtitle">
                        <Translate value={subtitle} />
                    </div>
                </div>
            );
        }

        return (
            <div className="col-xs-3 step">
                {step}.
                <div className="setup-subtitle">
                    <Translate value={subtitle} />
                </div>
            </div>
        );
    };

    getOfflineWizardStep = (step, subtitle = "") => {
        if (this.props.onlineActivation) {
            return null;
        }

        if (this.props.processStep === step) {
            return (
                <div className="col-xs-3 step active">
                    {step}.
                    <div className="setup-subtitle">
                        <Translate value={subtitle} />
                    </div>
                </div>
            );
        }

        return (
            <div className="col-xs-3 step">
                {step}.
                <div className="setup-subtitle">
                    <Translate value={subtitle} />
                </div>
            </div>
        );
    };

    getLicenseProcessSteps = () => {
        if (this.props.processStep === 0) {
            return "";
        }

        return (
            <div className="license-wizard">
                <div className="row">
                    {this.getWizardStep(1, translate("basicSetup.identificationKeys"))}
                    {this.getWizardStep(2, translate("basicSetup.productSelection"))}
                    {this.getWizardStep(3, translate("basicSetup.registrationForm"))}
                    {this.getOfflineWizardStep(4, translate("basicSetup.offlineLicensing"))}
                </div>
            </div>
        );
    };

    getLicenseBody = () => {
        if (this.props.processStep === 4) {
            return <LicenseRequest />;
        }

        if (this.props.processStep === 1) {
            return <LicenseIdentificationForm />;
        }

        if (this.props.processStep === 2) {
            return <LicenseProductForm />;
        }

        if (this.props.processStep === 3) {
            return <LicenseRegistrationForm />;
        }

        return <LicenseMessage />;
    };

    getSetupWizardTooltipWindow = () => {
        if (!this.props.setupSoftware) {
            return "";
        }

        if (this.props.processStep === 1) {
            return (
                <div className="col-xs-12 machine-help slim-scroll">
                    <div className="machine-help-icon">
                        <ReactSVG src={imgHelp} className="help-icon react-svg-icon" alt="help" />
                    </div>
                    <Translate value="basicSetup.learnIdentification" />
                </div>
            );
        }

        if (this.props.processStep === 2) {
            return (
                <div className="col-xs-12 machine-help slim-scroll">
                    <div className="machine-help-icon">
                        <ReactSVG src={imgHelp} className="help-icon react-svg-icon" alt="help" />
                    </div>
                    <Translate value="basicSetup.selectProducts" />
                </div>
            );
        }

        if (this.props.processStep === 3) {
            return (
                <div className="col-xs-12 machine-help slim-scroll">
                    <div className="machine-help-icon">
                        <ReactSVG src={imgHelp} className="help-icon react-svg-icon" alt="help" />
                    </div>
                    <Translate value="basicSetup.askSupplier" />
                </div>
            );
        }

        if (this.props.processStep === 4) {
            return (
                <div className="col-xs-12 machine-help slim-scroll">
                    <div className="machine-help-icon">
                        <ReactSVG src={imgHelp} className="help-icon react-svg-icon" alt="help" />
                    </div>
                    <Translate value="basicSetup.asterisk" />
                </div>
            );
        }
        return <div />;
    };

    render() {
        return (
            <React.Fragment>
                {this.getLicenseProcessSteps()}
                {this.getLicenseBody()}
                {this.getSetupWizardTooltipWindow()}
            </React.Fragment>
        );
    }
}

export default LicenseWizard = connect((store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        processStep: store.license.processStep,
        onlineActivation: store.license.onlineActivation
    };
})(LicenseWizard);
